import type { LandlordLocaleOverrides } from '../base';

export const NYOverrides: LandlordLocaleOverrides = {
  locale: 'NY',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText:
                'Copy legal description from appraisal district site. Be sure lot and block is only included in the lot and block fields above and does not repeat in this field...',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
          },
        },
        leaseAgreementDatesCard: {
          fields: {
            paymentDate: {
              name: 'paymentDate',
              label: 'Expected Close Date',
              tooltip: 'Date expected for lease approval (HOA, Co-op, other)',
            },
          },
        },
      },
    },
  },
};
